import * as React from 'react';
import { ValidationError } from '../../infrastructure/ValidationResult';

export interface ButtonSectionProps {
    children: any;
    noBorder?: boolean;
    validationErrors?: ValidationError[];
}

export function ButtonSection(props: ButtonSectionProps) {
    let classes = 'button-section';

    if (props.noBorder !== undefined && props.noBorder) {
        classes += ' no-border';
    }

    let errors;
    if (props.validationErrors !== undefined) {
        errors = props.validationErrors.map((error, i) =>
            (
                <div className='error-message'> 
                    <p>{error.error}</p>                    
                </div>
            )
        );
    }

    return (
        <div className={classes}>
            {props.children}
            {errors}
        </div>
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/ButtonSection.tsx